import React, {Fragment} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {Can} from "../../ability-context";
import _ from "lodash";
import createLink from "../../libs/createLink";

import {fetchMediaviewerMedia, resetMediaviewerMedia} from "../../creators/mediaviewer.media";
import {deleteMedia, updateMedia} from "../../creators/media";
import {reportMedia} from "../../creators/report";

import DateSince from './Date';
//import TagList from './TagList';
import Dropdown from './Dropdown';
import Player from './Player';
import Avatar from './Avatar';
//import Views from '../components/Views';
import Report from './Report';
import {PageLoader, SpinLoader} from './Loader';
import Icon from './Icon';
import MoveMedia from './MoveMedia';
import Alert from './Alert';
import Title from "./Title";

import ViewMore from './ViewMore';
import MediaComments from "./comments/MediaComments";
import Modal from "./Modal";
import LikeList from "./Like/LikeList";
import LikeBtn from "./Like/LikeBtn";
import DraftContentReader from "./editor/DraftContentReader";
import {
    canonical,
    contentRawToText,
    cropText, genererViews,
    isBot,
    isNoFollowAlbum, isNoFollowMedia, isNoFollowProfil,
    separateurNumber
} from "../../libs/helper";
import Helmet from "react-helmet";
import Breadcrumbs from "./Breadcrumbs";
import {Button} from "./Button";
import SwipeableHook from "../hoc/Swipeable";
//import Image from "./Image";
//import {apiCropImage} from "../../config";
import Advertising from "./Advertising/Advertising";
import {mediaViews} from "../../creators/views";
import ErrorNotFound from "../pages/ErrorNotFound";
import ViewsComment from "./ViewComment";
import MediaEdit from "../components2/mediaEdit/MediaEdit";
import EncourageSignup from "../components2/encourageSignup/EncourageSignup";
import Warning from "./warnings/Warning";


class MediaViewer extends React.Component {
    constructor(props) {
        super(props);
        let toggleMediaEdit = false;
        if(window.location.hash.match(/[#&]edit/) && this.props.isPage){
            let url = window.location.href.replace("#edit", "");
            window.history.pushState("", "",url);
            toggleMediaEdit = true;
        }

        this.state = {
            mediaLoaded: false,
            error: false,
            changeClassClassic: "classic",
            activeFullScreen: false,
            movePicture: false,
            deletePictureAlert: false,
            mediaContent: this.props.media,
            height: 0,
            isHidden: false,
            toggleMediaEdit: toggleMediaEdit,
            desactivatePictureAlert: false,
            isArrow: false,
            toggleLikeList: false,
            toggleEncourageSignup : false,
            toggleWarning : false
        };
        this.handleMediaLoaded = this.handleMediaLoaded.bind(this);
        this.nextThumb = this.nextThumb.bind(this);
        this.prevThumb = this.prevThumb.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.fullscreen = this.fullscreen.bind(this);
        this.handleDeletePicture = this.handleDeletePicture.bind(this);
        this.enableArrow = this.enableArrow.bind(this);
        this.handleMovePicture = this.handleMovePicture.bind(this);
        this.handlePicture = this.handlePicture.bind(this);
        this.handleStatusMedia = this.handleStatusMedia.bind(this);
        this.fetchMedia = this.fetchMedia.bind(this);
        this.handleReport = this.handleReport.bind(this);

        document.addEventListener("keydown", this.handleKeyPress);
        this.props.resetMediaviewerMedia();
        this.fetchMedia(this.props.mediaId ? this.props.mediaId : 0, this.props.mediaSlug ? {slug: this.props.mediaSlug} : {});
        //this.setRef = this.setRef.bind(this);
    }


    componentWillUnmount() {
        this.props.resetMediaviewerMedia();
        document.removeEventListener("keydown", this.handleKeyPress);
    }
/*
    setRef(player, media) {
        if(player){
            player.addEventListener('pause', this.onPause);
            player.addEventListener('play', ()=>{
                console.log("player");
                player.pause();
                console.log(player.currentTime);
            });
        }
    }

    onPause = (event) => {
        let {currentTime = 0} = event.target;
        console.log("onSeeked",currentTime);
    }*/

    /*componentDidUpdate(prevProps) {
        if (this.props.media._id !== prevProps.media._id && this.props.match) {
            let url = createLink(this.props.media.kind === "video" ? "mediaviewerVideo" : "mediaviewerPhoto", {...this.props.media.owner, media : this.props.media});
            if(this.props.match.url !== url){
                window.history.pushState("", "",url);
            }
        }
    }*/

    fetchMedia(id, query = {}) {
        let checkForHexRegExp = new RegExp("^[0-9a-fA-F]{24}$");
        if(checkForHexRegExp.test(id)){
            this.props.fetchMediaviewerMedia(id, query);
            this.props.mediaViews(id);
            if(!this.props.currentUserInitialized && !isBot){
                let total = parseInt(sessionStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_ms_total`)) || 0;
                let dateNow = parseInt((new Date().getTime() / 1000).toFixed(0));

                let dateVisite = parseInt(sessionStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_ms_date`)) || dateNow;
                let dateExpireVisite = parseInt((dateVisite + ( 60 * 10 )).toFixed(0));

                total++;

                if(total > 10 && dateExpireVisite >= dateNow){
                    total = 1;
                    this.setState({toggleEncourageSignup : true});
                }
                else if(dateExpireVisite < dateNow){
                    total = 1;
                    dateVisite = dateNow;
                }
                sessionStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_ms_date`, dateVisite);
                sessionStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_ms_total`, total);

            }

        }
    }

    handleMediaLoaded() {
        this.setState({mediaLoaded: true, error: false});
    }

    handleErrorLoaded() {
        this.setState({mediaLoaded: false, error: true});
    }

    nextThumb() {
        if(!this.props.mediaLoading && !this.state.toggleEncourageSignup){
            this.setState({mediaLoaded: false, error: false});
            let countThumb = this.props.media.collections && this.props.media.collections.length - 1;
            let currentIndex = countThumb && this.props.media.collections.findIndex(item => item._id === this.props.media._id) + 1;
            if (currentIndex > countThumb) {
                currentIndex = 0;
            }
            this.fetchMedia(this.props.media.collections[currentIndex]._id || this.props.mediaId);
            window.history.pushState("", "", createLink(this.props.media.kind === "video" ? "mediaviewerVideo" : "mediaviewerPhoto", {...this.props.owner, media : {_id : this.props.media.collections[currentIndex]._id, slug : this.props.media.collections[currentIndex].slug}}));
        }
    }

    prevThumb() {
        if(!this.props.mediaLoading && !this.state.toggleEncourageSignup){
            this.setState({mediaLoaded: false, error: false});
            let countThumb = this.props.media.collections && this.props.media.collections.length - 1;
            let currentIndex = countThumb && this.props.media.collections.findIndex(item => item._id === this.props.media._id) - 1;
            if (currentIndex < 0) {
                currentIndex = countThumb;
            }
            this.fetchMedia(this.props.media.collections[currentIndex]._id || this.props.mediaId);
            window.history.pushState("", "", createLink(this.props.media.kind === "video" ? "mediaviewerVideo" : "mediaviewerPhoto", {...this.props.owner, media : {_id : this.props.media.collections[currentIndex]._id, slug : this.props.media.collections[currentIndex].slug}}));
        }
    }


    fullscreen() {
        this.setState({activeFullScreen: !this.state.activeFullScreen});
    }

    handleKeyPress({key}) {
        let isArrow = this.props.media.collections && this.props.media.collections.length >= 2;
        switch (key) {
            case 'ArrowRight':
                if (isArrow && !this.props.mediaLoading) this.nextThumb();
                break;
            case 'ArrowLeft':
                if (isArrow && !this.props.mediaLoading) this.prevThumb();
                break;
            case 'Escape':
                if (this.state.activeFullScreen) {
                    this.fullscreen();
                } else {
                    if (typeof (this.props.handleClose) === 'function') this.props.handleClose();
                }
                break;
            default:
        }
    }

    enableArrow(active = true) {
        if (active) {
            document.addEventListener("keydown", this.handleKeyPress);
        } else {
            document.removeEventListener("keydown", this.handleKeyPress);
        }
    }

    handleDeletePicture() {
        this.props.deleteMedia(this.props.media._id);
        if (this.props.media.collections.length && this.props.media.collections.length >= 2) {
            this.nextThumb();
        } else {
            if(typeof this.props.handleClose === "function"){
                this.props.handleClose();
            }
        }
        this.setState({deletePictureAlert: false});
    }

    handleMovePicture() {
        this.setState({movePicture: false});
        if (this.props.media.collections.length) {
            this.nextThumb();
        } else {
            this.props.handleClose();
        }
    }

    handlePicture() {
        setTimeout(() => this.fetchMedia(this.props.mediaId ? this.props.mediaId : 0), 500);
        this.setState({toggleMediaEdit: false})
    }

    handleStatusMedia() {
        this.props.updateMedia(this.props.media._id, {status: !this.props.media.status});
        this.setState({desactivatePictureAlert: false})
    }

    handleReport(message){
        this.props.reportMedia(this.props.media._id, {message});
    }


    render() {
        if(this.props.isPage && _.get(this.props.mediaError,"statusCode") === 404){
            return <ErrorNotFound />
        }
        let linkAlbum = "";
        let relLinkAlbum = {};
        let relLinkProfil = {};
        let relLinkMedia = {};

        let ownerMedia = {
            _id: null,
                username: 'guest',
                slug: '',
                profile: {
                avatar: '',
                    gender: ''
            }
        };
        if(this.props.mediaInitialized){
           let newOwnerMedia = _.get(this.props.media, 'owner') || {};
            ownerMedia  = {
                ...ownerMedia,
                ...newOwnerMedia
            }
        }

        if(this.props.mediaInitialized && this.props.media.album){
            linkAlbum = createLink("userAlbum", {...ownerMedia, album : {_id : this.props.media.album._id, slug : this.props.media.album.slug}});
            relLinkAlbum = isNoFollowAlbum(this.props.media.album) ? { rel: "nofollow" } : {};
            relLinkProfil = isNoFollowProfil(ownerMedia) ? { rel: "nofollow" } : {};
            relLinkMedia = isNoFollowMedia(this.props.media) ? { rel: "nofollow" } : {};
        }
        let urlCanonical = canonical(createLink(this.props.media.kind === "video" ? "mediaviewerVideo" : "mediaviewerPhoto", {...ownerMedia, media : this.props.media}), "", "mediaviewver");
        let heightLimit = 18 * 5;
        let isArrow = this.props.media.collections && this.props.media.collections.length >= 2;

        //let metaLeywords = this.props.media.tags && this.props.media.tags.map(item => item.title).join();



        let breadCrumbsData = [];

        if(this.props.mediaInitialized) {
            let titleMedia = _.get(this.props, "media.title") || "";
            if (this.props.media.kind === "video") {
                breadCrumbsData.push({
                    name: "Vidéos Sexe",
                    link: canonical(createLink("videos"), "", "videos"),
                    to: createLink("videos"),
                    relLink : {}
                });
            } else {
                breadCrumbsData.push({
                    name: "Photos Sexe",
                    link: canonical(createLink("photos"), "", "photos"),
                    to: createLink("photos"),
                    relLink : {}
                });
            }

            breadCrumbsData.push({
                name: _.get(this.props, "media.owner.username"),
                link: canonical(createLink("userProfile", ownerMedia), "", "profile"),
                to: createLink("userProfile", ownerMedia),
                relLink : relLinkProfil
            });
            breadCrumbsData.push({
                name: _.get(this.props, "media.album.title"),
                link: canonical(linkAlbum, "", "album"),
                to: linkAlbum,
                relLink : relLinkAlbum
            });
            breadCrumbsData.push({
                name: titleMedia !== "" ? titleMedia : "N/A",
                link: urlCanonical,
                to: createLink(this.props.media.kind === "video" ? "mediaviewerVideo" : "mediaviewerPhoto", {
                    ...ownerMedia,
                    media: this.props.media
                }),
                relLink : relLinkMedia
            });
        }

        return !this.props.mediaInitialized ? <PageLoader/> : (
            <Fragment>
                <EncourageSignup toggle={this.state.toggleEncourageSignup} handleClose={()=>this.setState({toggleEncourageSignup : false})} />
                {this.props.isPage ? <Advertising sizeMobile={"300x100"} className={"center"} /> : null}
                <div className={`media-viewer ${this.state.activeFullScreen ? 'active' : ''} ${this.props.isPage ? 'mediaviewer-page' : ''}`}>
                    <Helmet>
                        <title>{this.props.media.kind === 'video' ? 'Vidéo' : "Photo"} {this.props.media.title} ({this.props.media.album && this.props.media.album.title ? this.props.media.album.title : ''}) - Voissa</title>
                        <meta name="description" content={cropText(contentRawToText(this.props.media.contentRaw), 130)} />
                        <link rel="canonical" href={urlCanonical} />
                        {/*metaLeywords && (<meta name="keywords" content={metaLeywords} />)*/}
                        {isNoFollowMedia(this.props.media) ? <meta name="robots" content="noindex" /> : null}

                    </Helmet>
                    <div className="media-layout">
                        <SwipeableHook
                            className={"media-main-wrapper"}
                            paramsSwipe={
                                {
                                    onSwipedLeft: () => this.props.media.kind === "video" ? null : this.prevThumb(),
                                    onSwipedRight: () => this.props.media.kind === "video" ? null : this.nextThumb(),
                                    preventDefaultTouchmoveEvent: true,
                                    trackMouse: false
                                }
                            }
                        >

                                {this.props.isPage && (
                                    <div className={"nav-breadcrumbs"} id={"test"}>
                                        <Breadcrumbs data={breadCrumbsData} />
                                    </div>
                                )}
                                {!this.props.mediaLoading && !this.props.media.status && <div className="desactivated-layer">
                                    <span className="badge red desactivated-badge">Media désactivé</span>
                                </div>}
                                {!this.props.media.display ? <div className="desactivated-layer">
                                    <span
                                        className="badge red display-warning"
                                          onClick={()=>this.setState({toggleWarning : true})}
                                      >Médias invisibles - Consulter le message de la modération sur votre profil
                                    </span>
                                </div> : null }
                                {((this.props.mediaLoading && this.props.media.kind !== 'video') ? <SpinLoader/> : '')}
                                {(!this.props.mediaLoading && this.props.media.kind === 'video') ? (
                                    <div className={`wrapper-img media-main-wrapper ${(!isBot && !this.state.mediaLoaded) && 'loading'}`}>
                                        <Player media={this.props.media} />
                                        <div className={`infos-media`}>
                                            {this.props.media.collections && this.props.media.collections[0] ?
                                                <div>
                                                    <div className="previous" onClick={_ => {
                                                        this.prevThumb()
                                                    }}><Icon type="chevron-left"/></div>
                                                    <div className="next" onClick={_ => {
                                                        this.nextThumb()
                                                    }}><Icon type="chevron-right"/></div>

                                                </div>
                                                : ''
                                            }
                                            {/*<Can action={"report"} subject={this.props} modelName="Media">
                                                <div className="report-btn">
                                                    <Report _id={this.props.media._id}
                                                            kind={"medias"}
                                                            type={"button"}
                                                            handleReport={this.handleReport}
                                                            title={this.props.media.title}/>
                                                </div>
                                            </Can>*/}
                                        </div>
                                    </div>
                                ) : (
                                    <div className={`wrapper-img ${(!isBot && !this.state.mediaLoaded) ? 'loading' : ""}`}>
                                        {!isBot && this.state.error && !this.props.mediaLoading && (<div className="no-image-found">Image introuvable</div>)}
                                        {!this.props.mediaLoading && (
                                            <Can action="clickRight" subject="Media" passThrough>
                                                {can => {
                                                    return (
                                                        <img
                                                            src={`${this.props.media.previewUrl}?wm=1`}
                                                            onLoad={()=>this.handleMediaLoaded()}
                                                            alt={this.props.media.title}
                                                            style={(!isBot && this.state.error) ? {'display': 'none'} : {}}
                                                            onError={()=>this.handleErrorLoaded()}
                                                            onContextMenu={!can ? (e)=> e.preventDefault() : null}
                                                        />)
                                                }}
                                            </Can>

                                        )}
                                        <div className={`infos-media ${(!isBot && !this.state.mediaLoaded) && 'loading'}`}>
                                            <div className="fullscreen" onClick={this.fullscreen}>
                                                {!this.state.activeFullScreen ? (
                                                    <Icon type="arrows-alt"/>
                                                ) : (
                                                    <Icon type="compress"/>
                                                )}
                                            </div>
                                            {this.props.media.collections && this.props.media.collections[0] ?
                                                <Fragment>
                                                    {isArrow && (<div className="previous" onClick={_ => {
                                                        this.prevThumb()
                                                    }}><Icon type="chevron-left"/></div>)}
                                                    {isArrow && (<div className="next" onClick={_ => {
                                                        this.nextThumb()
                                                    }}><Icon type="chevron-right"/></div>)}
                                                </Fragment>
                                                : ''
                                            }

                                        </div>
                                    </div>
                                )}

                        </SwipeableHook>
                        <div className="media-sidebar">
                            {this.props.mediaLoading ? <PageLoader/> : (
                                <Fragment>
                                    <div className="media-informations">
                                        <div className="media-user">
                                            <div>
                                                <Link
                                                    to={createLink("userProfile", ownerMedia)}
                                                    {...relLinkProfil}
                                                    className="user link">
                                                    <Avatar avatar={_.get(ownerMedia,"profile.avatar") || ""}
                                                            gender={_.get(ownerMedia,"profile.gender") || 0}
                                                            width={150}
                                                            height={150}
                                                            alt=""/>
                                                </Link>
                                            </div>
                                            <div className="media-user-info">
                                                <div className="topline">
                                                    {ownerMedia._id ? (
                                                        <div>
                                                            <Link
                                                                to={createLink("userProfile", ownerMedia)}
                                                                {...relLinkProfil}
                                                                className="user link">{ownerMedia.username}</Link>
                                                            <DateSince
                                                                date={this.props.media.createdAt}
                                                                prefix={false}
                                                                currentFormat={true}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <div className="user link">{this.props.media.authorName}</div>
                                                            <DateSince
                                                                date={this.props.media.createdAt}
                                                                prefix={false}
                                                                currentFormat={true}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="album-infos">
                                                    Dans l'album&nbsp;
                                                    {this.props.urlAlbum === linkAlbum ? (
                                                        <Link to={"#"} className="album link"
                                                             onClick={() => this.props.handleClose()}
                                                              {...relLinkAlbum}
                                                        >
                                                            {this.props.media.album && this.props.media.album.title ? this.props.media.album.title : ''}
                                                        </Link>
                                                    ) : (
                                                        <Link
                                                            to={linkAlbum}
                                                            {...relLinkAlbum}
                                                            className="album link">{this.props.media.album && this.props.media.album.title ? this.props.media.album.title : ''}</Link>
                                                    )}

                                                    {/*<Button size={"small"}*/}
                                                    {/*to={`/albums/${this.props.media.owner._id}-${this.props.media.owner.slug}`}*/}
                                                    {/*style={"primary-reverse"}*/}
                                                    {/*content={"Voir tous ses albums"}/>*/}
                                                </div>
                                            </div>
                                            {_.get(this.props, 'currentUser._id') ? (
                                                <Dropdown align="right" activableComponent={(
                                                    <Icon type={"vertical-dots"}/>
                                                )}>
                                                    <ul className="dropdown-menu">
                                                        <Can action={"update"} subject={this.props.media} modelName="Media">
                                                            <li className="menu-item"
                                                                onClick={() => this.setState({toggleMediaEdit: true})}><Icon
                                                                type="pencil"/> Editer
                                                            </li>
                                                        </Can>
                                                        <Can action={"move"} subject={this.props.media} modelName="Media">
                                                            <li className="menu-item"
                                                                onClick={() => this.setState({movePicture: true})}><Icon
                                                                type="long-arrow-right"/> Déplacer dans un autre album
                                                            </li>
                                                        </Can>
                                                        <Can action={"status"} subject={this.props.media} modelName="Media">
                                                            <li className="menu-item"
                                                                onClick={() => this.setState({desactivatePictureAlert: true})}>
                                                                <Icon
                                                                    type={this.props.media && this.props.media.status ? 'lock' : 'unlock'}/> {this.props.media.status ? 'Désactiver' : 'Activer'}
                                                            </li>
                                                        </Can>
                                                        <Can action={"delete"} subject={this.props.media} modelName="Media">
                                                            <li className="menu-item"
                                                                onClick={() => this.setState({deletePictureAlert: true})}>
                                                                <Icon
                                                                    type="close"/> Supprimer
                                                            </li>
                                                        </Can>
                                                        <Can action={"report"} subject={this.props} modelName="Media">
                                                            <li className="menu-item">
                                                                <Report _id={this.props.media._id}
                                                                        kind={"medias"}
                                                                        type={"comment"}
                                                                        handleReport={this.handleReport}
                                                                        title={this.props.media.title}/>
                                                            </li>
                                                        </Can>
                                                    </ul>
                                                </Dropdown>
                                                ) : null}

                                            <Modal toggle={this.state.deletePictureAlert}
                                                   handleClose={() => this.setState({deletePictureAlert: false})}>
                                                <Alert text="Voulez-vous vraiment supprimer ce média ?"
                                                       handleClose={() => this.setState({deletePictureAlert: false})}
                                                       handleDelete={() => this.handleDeletePicture()}/>
                                            </Modal>
                                            <Modal toggle={this.state.desactivatePictureAlert}
                                                   handleClose={() => this.setState({desactivatePictureAlert: false})}>
                                                <Alert
                                                    text={`Voulez-vous vraiment ${this.props.media.status ?  'désactiver' : 'Activer'} ce média ?`}
                                                    handleClose={() => this.setState({desactivatePictureAlert: false})}
                                                    handleDelete={() => this.handleStatusMedia()}/>
                                            </Modal>
                                            <Modal toggle={this.state.movePicture}
                                                   handleClose={() => this.setState({movePicture: false})}>
                                                <MoveMedia
                                                    handleMovePicture={this.handleMovePicture}
                                                    mediaId={this.props.media._id}
                                                    handleClose={() => this.setState({movePicture: false})}
                                                    ownerId={_.get(this.props,"media.owner._id")}
                                                    activeAlbumId={this.props.media && this.props.media.album && this.props.media.album._id}
                                                />
                                            </Modal>
                                            <Modal toggle={this.state.toggleMediaEdit}
                                                   handleClose={() => this.setState({toggleMediaEdit: false})}>
                                                <MediaEdit
                                                    currentMediaId={this.props.media._id}
                                                    handleClose={this.handlePicture}
                                                />
                                            </Modal>
                                            <Modal toggle={this.state.toggleWarning}
                                                   handleClose={() => this.setState({toggleWarning: false})}>
                                                <Warning username={_.get(this.props.media,"owner.username") || ""}
                                                         userId={_.get(this.props.media,"owner._id") || null}
                                                         handleClose={() => this.setState({toggleWarning: false})}/>
                                            </Modal>
                                        </div>
                                        <div className="like-infos">
                                            {this.props.media._id &&
                                            <LikeBtn parentId={this.props.media._id}
                                                     isLiked={this.props.media.isLiked}
                                                     likeType={"medias"} />
                                            }
                                        </div>
                                        <div className="media-infos column">
                                            <Title heading={"heading-2"}
                                                   className={this.props.media.contentRaw && this.props.media.contentRaw.blocks && this.props.media.contentRaw.blocks.length >= 1 ? 'pb-8' : ''}
                                                   display={"display-5"}>{this.props.media.title}</Title>
                                            {!this.props.isPage ? <Advertising sizeMobile={"300x100"} className={"center"} /> : null}
                                            <ViewMore limit={heightLimit}>
                                                <DraftContentReader contentRaw={this.props.media.contentRaw} />
                                            </ViewMore>
                                            {/*this.props.media.tags && this.props.media.tags.length >= 1 && (
                                                <div className="wrapper-tag">
                                                    <TagList tags={this.props.media.tags || []} type={this.props.media.kind === "video" ? "tagVideo" : "tagPhoto"} owner={this.props.media.owner}/>
                                                </div>
                                            )*/}
                                        </div>
                                        <div className={"suggestions-group"}>
                                            {this.props.media.categories && this.props.media.categories.map(item=>(
                                                <Link key={item._id} to={createLink('facette', {slug : item.uri})}>
                                                    <Button
                                                        size={"small"}
                                                        btnStyle={"primary-reverse"}
                                                        //onClick={() => this.setState({toggle : true})}
                                                        content={item.title}/>
                                                </Link>
                                            ))}
                                        </div>

                                        <div className="group-link">
                                            <ul className="ul-link">
                                                {this.props.media._id &&
                                                    <Fragment>
                                                        <span  className={`media-stats likes-text ${this.props.media.count.like >= 1 ? "cursor-pointer" : "" }`} onClick={()=>this.props.media.count.like >= 1 ? this.setState({toggleLikeList: true}) : null}>
                                                            <Icon type={"heart-full"} />
                                                            {separateurNumber(this.props.totalLikes || this.props.media.count.like)}
                                                        </span>
                                                        <Modal toggle={this.state.toggleLikeList} handleClose={()=>this.setState({toggleLikeList: false})}>
                                                            <LikeList handleClose={()=>this.setState({toggleLikeList: false})}
                                                                      value={this.props.media.count.like}
                                                                      likeType={"medias"}
                                                                      parentId={this.props.media._id} />
                                                        </Modal>
                                                    </Fragment>
                                                }
                                                <div className={`media-stats`}>
                                                    <Icon type="eye"/> {separateurNumber(genererViews(this.props.media?.count?.view || 0)) || 0}
                                                </div>
                                                <ViewsComment type={"icon"} className="media-stats" value={this.props.media.count && separateurNumber(this.props.media.count.comment)}/>
                                                {/*<span className={"media-stats share-link"}>*/}
                                                {/*    Partager*/}
                                                {/*</span>*/}
                                            </ul>
                                        </div>
                                    </div>
                                    <MediaComments
                                        mediaId={this.props.media._id}
                                        media={this.props.media}
                                        commentType={"medias"}
                                        isMore={true}
                                        enableArrow={this.enableArrow}
                                        commentsAllowed={_.get(this.props,"media.comment.allowed") || false}
                                    />
                                </Fragment>
                            )}
                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }
}

MediaViewer.defaultProps = {
    media: {
        title: '',
        description: '',
        view: 0,
        type: 'gallery',
        mediaSrc: '',
        createdAt: 0,
        album: {
            slug: '',
            title: ''
        },
        tags: [],
        owner: {
            _id: 0,
            username: '',
            slug: '',
            profile: {
                avatar: '',
                gender: ''
            }
        },
        collections: [],
        previewUrl : ""
    }
};

const mapStateToProps = (state) => {
    return {
        media: state.mediaviewerMedia.data,
        mediaLoading: state.mediaviewerMedia.loading,
        mediaInitialized: state.mediaviewerMedia.initialized,
        mediaError: state.mediaviewerMedia.error,
        totalLikes: state.likes.total,
        currentUser: state.currentUser.data,
        currentUserInitialized: state.currentUser.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchMediaviewerMedia,
    resetMediaviewerMedia,
    deleteMedia,
    updateMedia,
    reportMedia,
    mediaViews
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MediaViewer);
